import styled from 'styled-components';

export const DropdownWrapper = styled.div`
  position: fixed;
  bottom: 0.5em;
  left: 1em;
  z-index: 1;
`;
